function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling !== null) {
    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.currentTarget.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    const values = this.optionValueIds();
    try {
      const variant = JSON.parse(this.querySelector('[data-selected-variant]')?.textContent || 'null');
      const selectedOptions = [...this.querySelectorAll('fieldset, select')].map(control =>
        control.tagName === 'SELECT' ? control.value : control.querySelector('input:checked')?.value);
      if (variant?.available && /^\d+$/.test(String(variant.id)) &&
        variant.options?.every((option, index) => option === selectedOptions[index]) &&
        values.length === variant.options.length && values.every(value => /^\d+$/.test(value || ''))) {
        this.currentVariant = variant;
        this.confirmedOptionValues = values.join(',');
      }
    } catch (_) {
      // A malformed initial picker must never confirm a purchasable variant.
    }
    if (!this.currentVariant) {
      this.updateVariantInput();
      this.toggleAddButton(true);
    }
    this.toggleDynamicCheckout(Boolean(this.currentVariant));
  }

  optionValueIds() {
    return [...this.querySelectorAll('fieldset, select')].map(control => control.tagName === 'SELECT'
      ? control.selectedOptions[0]?.dataset.optionValueId
      : control.querySelector('input:checked')?.dataset.optionValueId);
  }

  hasConfirmedSelection() {
    const values = this.optionValueIds();
    return Boolean(this.currentVariant?.available && this.confirmedOptionValues &&
      this.confirmedOptionValues === values.join(',') && values.every(value => /^\d+$/.test(value || '')));
  }

  toggleDynamicCheckout(enabled) {
    const section = this.closest('.shopify-section');
    if (section?.querySelector('[data-fp-option-group], [data-fp-option-property]') && !window.FPProductOptions) enabled = false;
    const checkout = section?.querySelector('[data-fp-dynamic-checkout]');
    if (checkout) checkout.inert = !enabled;
    window.FPProductOptions?.gate(section, enabled ? undefined : false);
  }

  async onVariantChange(event) {
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();
    this.confirmationController?.abort();
    this.confirmationController = new AbortController();
    const signal = this.confirmationController.signal;
    const generation = this.generation = (this.generation || 0) + 1;
    this.currentVariant = null;
    this.confirmedOptionValues = null;
    this.updateVariantInput();
    this.toggleDynamicCheckout(false);
    const values = this.optionValueIds();
    if (values.some(value => !/^\d+$/.test(value || ''))) { this.setUnavailable(); return; }
    try {
      const url = new URL(this.dataset.url, location.origin);
      if (window.Shopify?.theme?.role === 'unpublished') {
        url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
      }
      url.searchParams.set('option_values', values.join(','));
      url.searchParams.set('section_id', this.dataset.originalSection || this.dataset.section);
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('Variant response failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (signal.aborted || generation !== this.generation) return;
      const picker = html.querySelector(`variant-selects[data-section="${this.dataset.originalSection || this.dataset.section}"]`);
      const selected = picker?.querySelector('[data-selected-variant]');
      if (!selected) throw new Error('Variant confirmation missing');
      if (!html.getElementById(`price-${this.dataset.originalSection || this.dataset.section}`) ||
        !html.getElementById(`ProductSubmitButton-${this.dataset.originalSection || this.dataset.section}`)) {
        throw new Error('Variant section incomplete');
      }
      const variant = JSON.parse(selected.textContent);
      // The rendered picker must resolve the same option value IDs submitted.
      const rendered = [...picker.querySelectorAll('fieldset, select')].map(control =>
        control.tagName === 'SELECT' ? control.selectedOptions[0]?.dataset.optionValueId
          : control.querySelector('input:checked')?.dataset.optionValueId);
      if (rendered.join(',') !== values.join(',')) throw new Error('Variant confirmation mismatch');
      this.updateOptionAvailability(picker);
      if (!variant || !/^\d+$/.test(String(variant.id)) || !variant.available ||
        variant.options?.length !== values.length) { this.setUnavailable(); return; }
      this.currentVariant = variant;
      this.confirmedOptionValues = values.join(',');
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updatePickupAvailability();
      this.renderProductInfo(html);
      this.toggleDynamicCheckout(true);
      this.updateShareUrl();
    } catch (error) {
      if (!signal.aborted && generation === this.generation) {
        this.currentVariant = null;
        this.confirmedOptionValues = null;
        this.updateVariantInput();
        this.toggleDynamicCheckout(false);
        this.setUnavailable();
      }
    }
  }

  updateOptionAvailability(picker) {
    const current = [...this.querySelectorAll('fieldset, select')];
    const updated = [...picker.querySelectorAll('fieldset, select')];
    current.forEach((control, index) => {
      if (control.tagName !== updated[index]?.tagName) return;
      const originals = new Map([...control.querySelectorAll('[data-option-value-id]')]
        .map(item => [item.dataset.optionValueId, item]));
      for (const option of updated[index].querySelectorAll('[data-option-value-id]')) {
        const original = originals.get(option.dataset.optionValueId);
        if (!original) continue;
        if (original.tagName === 'INPUT') original.classList.toggle('disabled', option.classList.contains('disabled'));
        if (original.tagName === 'OPTION') original.textContent = option.textContent;
      }
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.textContent = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (newMediaModal) modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const url = new URL(this.dataset.url, location.origin);
    for (const name of ['preview_theme_id', '_fd', 'pb', 'locale', 'country', 'currency']) {
      const value = new URL(location.href).searchParams.get(name);
      if (value) url.searchParams.set(name, value);
    }
    if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
    url.searchParams.set('variant', this.currentVariant.id);
    window.history.replaceState(history.state, '', url.pathname + url.search);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant?.available ? this.currentVariant.id : '';
      input.disabled = !this.currentVariant?.available;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo(html) {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    {
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', !inventorySource || inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (this.closest('.shopify-section')?.querySelector('[data-fp-option-group], [data-fp-option-property]')) {
      productForm.closest('product-form').dataset.fpBaseReady = String(!disable);
      if (!window.FPProductOptions) addButton.disabled = true;
    }
    window.FPProductOptions?.gate(this.closest('.shopify-section'), !disable);
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class PPSlideshowoMobile extends HTMLElement {
  constructor() {
    super();

    this.mainCarouselMObile = this.querySelector('.main-carousel.mobile');
    this.img = this.querySelector('.carousel-cell.img');
    this.flickitySlider = this.querySelector('.flickity-slider');
    this.video = this.querySelector('.carousel-cell.video');
    this.filhoDivVideo = this.video ? this.video.querySelector('.video-mobile') : null;
    this.flickityViewport = this.querySelector('.flickity-viewport');
    this.imgsMobile = this.querySelectorAll('img.img-mobile');

    this.getHightBannerImage = this.getHightBannerImage.bind(this);
    window.addEventListener('resize', this.getHightBannerImage);
  }

  connectedCallback() {
    this.getHightBannerImage();
    this.setTranslateX0();
    this.oneSlideMobile();
  }

  //Regula a altura do vídeo de acordo com a altura da imagem se houver imagem e regula a altura do Flickity Viewport pelo tamanho do elemento;
  getHightBannerImage() {
    if (this.img) {
      const heightImg = this.img.offsetHeight - 9;
      if (this.flickityViewport) {
        this.flickityViewport.style.maxHeight = `${heightImg}px`;
      }
      if (this.video) {
        this.video.style.maxHeight = `${heightImg}px`;
        if (this.filhoDivVideo) {
          this.filhoDivVideo.style.height = `${heightImg}px`;
        }
      }
    }
  }

  //Se o elemento selecionado for uma imagem ele regula o translateX do elemento;
  setTranslateX0() {
    if (this.flickitySlider) {
      if (this.img.contains(this.querySelector('.carousel-cell.img.is-selected'))) {
        this.flickitySlider.style.transform = 'translateX(0)';
      }
    }
  }

  //Detecta se existe somente um slide no mobile e se tiver adiciona a classe no-slide
  oneSlideMobile() {
    if (this.imgsMobile.length == 1 && !this.video) {
      this.mainCarouselMObile.classList.add('no-slide');
    } else {
      this.mainCarouselMObile.classList.remove('no-slide');
    }
  }
}

customElements.define('pp-slideshow-mobile', PPSlideshowoMobile);

class PPSlideshowDesktop extends HTMLElement {
  constructor() {
    super();

    this.img = this.querySelector('.carousel-cell.img');
    this.flickitySlider = this.querySelector('.flickity-slider');
    this.video = this.querySelector('.carousel-cell.video');
    this.filhoDivVideo = this.video ? this.video.querySelector('.video-mobile') : null;
    this.flickityViewport = this.querySelector('.flickity-viewport');

    this.getHightBannerImage = this.getHightBannerImage.bind(this);
    window.addEventListener('resize', this.getHightBannerImage);
  }

  connectedCallback() {
    this.getHightBannerImage();
    this.setTranslateX0();
  }

  //Regula a altura do vídeo de acordo com a altura da imagem se houver imagem e regula a altura do Flickity Viewport pelo tamanho do elemento;
  getHightBannerImage() {
    if (this.img) {
      const heightImg = this.img.offsetHeight - 25;
      if (this.flickityViewport) {
        this.flickityViewport.style.maxHeight = `${heightImg}px`;
      }
      if (this.video) {
        this.video.style.maxHeight = `${heightImg}px`;
        if (this.filhoDivVideo) {
          this.filhoDivVideo.style.height = `${heightImg}px`;
        }
      }
    }
  }

  //Se o elemento selecionado for uma imagem ele regula o translateX do elemento;
  setTranslateX0() {
    if (this.flickitySlider) {
      if (this.img && this.img.contains(this.querySelector('.carousel-cell.img.is-selected'))) {
        this.flickitySlider.style.transform = 'translateX(0)';
      }
    }
  }
}

customElements.define('pp-slideshow-desktop', PPSlideshowDesktop);

class BreadcrumbCollection extends HTMLElement {
  constructor() {
    super();

    this.link = this.querySelector('a');
  }

  connectedCallback() {
    this.setReferrer();
  }

  // Seta o document.referrer no link
  setReferrer() {
    if (document.referrer) {
      this.link.href = document.referrer;
    } else {
      this.link.href = '/';
    }
  }
}

customElements.define('breadcrumb-collection', BreadcrumbCollection);

class FPDeferredScript extends HTMLElement {
  static loads = new Map();

  connectedCallback() {
    this.handleSectionLoad ||= () => this.arm();
    document.removeEventListener('shopify:section:load', this.handleSectionLoad);
    document.addEventListener('shopify:section:load', this.handleSectionLoad);
    this.arm();
  }

  disconnectedCallback() {
    this.cleanupTriggers();
    document.removeEventListener('shopify:section:load', this.handleSectionLoad);
  }

  arm() {
    if (this.dataset.fpState === 'loaded' || this.dataset.fpState === 'loading') return;

    this.cleanupTriggers();
    const targets = this.getTargets();
    if (!targets.length) return;

    this.targets = targets;

    const triggers = this.dataset.trigger || 'viewport';
    if (triggers.includes('intent')) {
      this.handleIntent ||= () => this.load(true);
      targets.forEach((target) => {
        target.addEventListener('pointerdown', this.handleIntent, { capture: true, passive: true });
        target.addEventListener('focusin', this.handleIntent, { capture: true });
      });
    }

    if (triggers.includes('viewport')) {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.load();
          },
          { rootMargin: this.dataset.rootMargin || '800px 0px' }
        );
        targets.forEach((target) => this.observer.observe(target));
      } else {
        this.load();
      }
    } else if (!triggers.includes('intent')) {
      this.load();
    }
  }

  getTargets() {
    const selector = this.dataset.matchSelector;
    if (!selector) return [this.parentElement || this];

    try {
      const targets = Array.from(document.querySelectorAll(selector), (target) => {
        const rect = target.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return target;

        return (
          target.closest('[data-fp-deferred-script-owner], .shopify-section, section, footer, main') ||
          target.parentElement ||
          target
        );
      });

      return Array.from(new Set(targets));
    } catch (error) {
      console.warn(`Invalid fp-deferred-script selector: ${selector}`, error);
      return [];
    }
  }

  static waitForExistingScript(script) {
    if (script.dataset.fpDeferredState === 'loaded') return Promise.resolve(script);
    if (script.dataset.fpDeferredState === 'failed') return Promise.reject(new Error('Script previously failed'));

    return new Promise((resolve, reject) => {
      const cleanup = () => {
        clearTimeout(timer);
        script.removeEventListener('load', handleLoad);
        script.removeEventListener('error', handleError);
      };
      const handleLoad = () => {
        cleanup();
        script.dataset.fpDeferredState = 'loaded';
        resolve(script);
      };
      const handleError = (error) => {
        cleanup();
        script.dataset.fpDeferredState = 'failed';
        reject(error);
      };

      const timer = setTimeout(() => handleError(new Error('Deferred script timed out after 10s')), 10000);
      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });
    });
  }

  load(explicitIntent = false) {
    const source = this.dataset.src;
    if (!source || this.dataset.fpState === 'loaded') return Promise.resolve();
    if (this.loadPromise) return this.loadPromise;
    if (this.dataset.fpState === 'failed' && (!explicitIntent || this.attempts >= 2)) return Promise.resolve();

    const url = new URL(source, document.baseURI).href;
    this.attempts = (this.attempts || 0) + 1;
    this.dataset.fpState = 'loading';

    let request = FPDeferredScript.loads.get(url);
    if (!request) {
      let existing = Array.from(document.scripts).find((script) => script.src === url);
      if (existing?.dataset.fpDeferredState === 'failed' && existing.dataset.fpDeferredOwned === 'true' && explicitIntent) {
        existing.remove();
        existing = null;
      }
      if (this.dataset.global && typeof window[this.dataset.global] === 'function') {
        request = Promise.resolve();
      } else if (existing) {
        request = FPDeferredScript.waitForExistingScript(existing);
      } else {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.dataset.fpDeferredState = 'loading';
        script.dataset.fpDeferredOwned = 'true';
        request = FPDeferredScript.waitForExistingScript(script);
        document.head.appendChild(script);
      }
      FPDeferredScript.loads.set(url, request);
    }

    this.loadPromise = request
      .then(() => {
        if (this.dataset.global && typeof window[this.dataset.global] !== 'function') {
          const script = Array.from(document.scripts).find((item) => item.src === url);
          if (script) script.dataset.fpDeferredState = 'failed';
          throw new Error('Deferred library is unavailable');
        }
        this.dataset.fpState = 'loaded';
        this.cleanupTriggers();
        this.dispatchEvent(
          new CustomEvent('fp:script-ready', { bubbles: true, detail: { src: url } })
        );
      })
      .catch((error) => {
        this.dataset.fpState = 'failed';
        this.loadPromise = null;
        this.observer?.disconnect();
        if (FPDeferredScript.loads.get(url) === request) FPDeferredScript.loads.delete(url);
        console.warn(`Unable to load deferred script: ${url}`, error);
      });

    return this.loadPromise;
  }

  cleanupTriggers() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.handleIntent) {
      this.targets?.forEach((target) => {
        target.removeEventListener('pointerdown', this.handleIntent, true);
        target.removeEventListener('focusin', this.handleIntent, true);
      });
    }
    this.targets = [];
  }
}

if (!customElements.get('fp-deferred-script')) {
  customElements.define('fp-deferred-script', FPDeferredScript);
}

function initFPPriorityMedia(root = document) {
  const scopes = root.matches?.('[data-fp-priority-media]') ? [root] : [];
  scopes.push(...root.querySelectorAll('[data-fp-priority-media]'));
  scopes.forEach((scope) => {
    if (scope.dataset.fpPriorityMediaArmed === 'true') return;
    scope.dataset.fpPriorityMediaArmed = 'true';
    const primary = scope.querySelector('.is-active img[src], .carousel-cell.img:not([data-fp-priority-deferred]) img[src]');
    const release = () => {
      primary?.removeEventListener('load', release);
      primary?.removeEventListener('error', release);
      scope.querySelectorAll('[data-fp-priority-srcset]').forEach((element) => {
        element.setAttribute('srcset', element.dataset.fpPrioritySrcset);
        element.removeAttribute('data-fp-priority-srcset');
      });
      scope.querySelectorAll('[data-fp-priority-src]').forEach((image) => {
        image.setAttribute('src', image.dataset.fpPrioritySrc);
        image.removeAttribute('data-fp-priority-src');
      });
    };
    if (!primary || primary.complete) release();
    else {
      primary.addEventListener('load', release, { once: true });
      primary.addEventListener('error', release, { once: true });
    }
  });
}

initFPPriorityMedia();
document.addEventListener('shopify:section:load', (event) => initFPPriorityMedia(event.target));
document.addEventListener('fp:connected-product-swapped', () => initFPPriorityMedia());

function initFPDeferredFlickity(root = document) {
  root.querySelectorAll('[data-fp-flickity]').forEach((carousel) => {
    if (carousel.dataset.fpFlickityReady === 'true') return;
    if (carousel.dataset.fpFlickityArmed === 'true') {
      carousel.fpFlickityActivate?.();
      return;
    }

    let options;
    try {
      options = JSON.parse(carousel.dataset.fpFlickity || '{}');
    } catch (error) {
      console.warn('Invalid deferred Flickity options', error);
      return;
    }

    carousel.dataset.fpFlickityArmed = 'true';

    let observer;
    let attempts = 0;
    const activate = (event) => {
      if (carousel.dataset.fpFlickityReady === 'true' || typeof window.Flickity !== 'function') return;
      const explicitIntent = event?.type === 'pointerdown' || event?.type === 'focusin';
      if (attempts && (!explicitIntent || attempts >= 2)) return;
      attempts += 1;
      try {
        const instance = window.Flickity.data?.(carousel) || new window.Flickity(carousel, options);
        if (!instance) throw new Error('Flickity initialization did not return an instance');
        carousel.dataset.fpFlickityReady = 'true';
        observer?.disconnect();
        carousel.removeEventListener('pointerdown', activate, true);
        carousel.removeEventListener('focusin', activate, true);
        delete carousel.fpFlickityActivate;
      } catch (error) {
        observer?.disconnect();
        try { window.Flickity.data?.(carousel)?.destroy(); } catch (_) { /* Keep other carousels independent. */ }
        console.warn('Unable to initialize shelf carousel', error);
      }
    };

    carousel.fpFlickityActivate = activate;

    carousel.addEventListener('pointerdown', activate, { capture: true, passive: true });
    carousel.addEventListener('focusin', activate, { capture: true });

    if (carousel.dataset.fpFlickityTrigger === 'immediate') {
      requestAnimationFrame(() => requestAnimationFrame(activate));
      return;
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) activate();
        },
        { rootMargin: '1000px 0px' }
      );
      observer.observe(carousel);
    } else {
      activate();
    }
  });
}

initFPDeferredFlickity();
document.addEventListener('shopify:section:load', (event) => initFPDeferredFlickity(event.target));
document.addEventListener('fp:script-ready', () => initFPDeferredFlickity());

function refreshFPTrustvoxRatings() {
  try {
    window.TrustvoxRatesWidget?.fillComponents?.();
  } catch (error) {
    console.warn('Unable to refresh Trustvox shelf ratings', error);
  }
}

document.addEventListener('fp:deferred-products-ready', refreshFPTrustvoxRatings);
document.addEventListener('shopify:section:load', () => requestAnimationFrame(refreshFPTrustvoxRatings));
document.addEventListener('fp:script-ready', (event) => {
  if (event.detail?.src?.includes('rate.trustvox.com.br/widget.js')) {
    requestAnimationFrame(refreshFPTrustvoxRatings);
  }
});

function initFPDeferredMedia(root = document) {
  root.querySelectorAll('[data-fp-deferred-media]').forEach((container) => {
    if (container.dataset.fpMediaInitialized === 'true') return;
    container.dataset.fpMediaInitialized = 'true';
    const autoplayVideos = container.querySelectorAll('video[data-fp-autoplay], video.fp-deferred-autoplay');
    const deferredPosters = container.querySelectorAll('video[data-fp-poster]');
    const deferredImages = container.querySelectorAll('img[data-fp-poster-src]');
    const loadImage = (image) => {
      if (!image.dataset.fpPosterSrc) return;
      image.srcset = image.dataset.fpPosterSrcset || '';
      image.src = image.dataset.fpPosterSrc;
      delete image.dataset.fpPosterSrcset;
      delete image.dataset.fpPosterSrc;
    };
    const loadPoster = (video) => {
      if (!video.dataset.fpPoster) return;
      video.poster = video.dataset.fpPoster;
      delete video.dataset.fpPoster;
      if (video.hasAttribute('data-fp-poster-needs-load')) video.load();
    };

    const load = () => {
      if (container.dataset.fpMediaLoaded === 'true') return;
      container.dataset.fpMediaLoaded = 'true';
      container.querySelectorAll('source[data-src], iframe[data-src], video[data-src]').forEach((media) => {
        media.src = media.dataset.src;
      });
      container.querySelectorAll('video').forEach((video) => {
        if (video.dataset.src || video.querySelector('source[data-src]')) video.load();
      });
    };

    if (!('IntersectionObserver' in window)) {
      deferredPosters.forEach(loadPoster);
      deferredImages.forEach(loadImage);
      load();
      autoplayVideos.forEach((video) => video.play().catch(() => {}));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        load();
      },
      { rootMargin: container.dataset.fpRootMargin || '600px 0px' }
    );
    observer.observe(container);
    const posterObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        posterObserver.unobserve(entry.target);
        loadPoster(entry.target);
      });
    }, { rootMargin: '300px 0px' });
    deferredPosters.forEach((video) => posterObserver.observe(video));
    let imageObserver;
    if (deferredImages.length) {
      imageObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          imageObserver.unobserve(entry.target);
          loadImage(entry.target);
        });
      }, { rootMargin: '100px 0px' });
      deferredImages.forEach((image) => imageObserver.observe(image));
    }
    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.01 }
    );
    autoplayVideos.forEach((video) => visibilityObserver.observe(video));
    container.fpMediaObservers = [observer, visibilityObserver, posterObserver, imageObserver].filter(Boolean);
    container.addEventListener('pointerdown', (event) => {
      const video = event.target.closest('[class*="video-social-item-"]')?.querySelector('video[data-fp-poster]');
      if (video) loadPoster(video);
    }, { capture: true, passive: true });
    container.addEventListener('pointerdown', load, { once: true, capture: true, passive: true });
    container.addEventListener('focusin', load, { once: true, capture: true });
  });
}

initFPDeferredMedia();
document.addEventListener('shopify:section:load', (event) => initFPDeferredMedia(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-fp-deferred-media]').forEach((container) => {
    container.fpMediaObservers?.forEach((observer) => observer.disconnect());
  });
});

// Comentário para evitar erro
